module.exports = __webpack_public_path__ + "img/promotional_bg.55ff37f4.png";